import React, {useCallback, useState} from 'react'
import {GoogleReCaptchaProvider, useGoogleReCaptcha} from "react-google-recaptcha-v3";
import {CAPTCHA_SITEKEY} from "../../../../util/recaptcha_utils";
import {sendBookConsultationDiscount, sendBookConsultationCallback, sendFreeGuide, sendFirstShootOffer} from "../../../../util/book_consultation_api_utils";
import {setCookie} from "../../../../util/cookie_utils";

// Matches the code these lead-gen forms email out (see
// BookConsultationsController#send_discount / #send_first_shoot_offer).
// Stashing it in a cookie here lets the homepage order flow auto-apply it
// later without the person needing to dig the code out of their email —
// works for brand-new visitors with no account yet.
const PENDING_DISCOUNT_COOKIE = "pending_discount_code"
const PENDING_DISCOUNT_CODE = "SAVE20"

const InitialInfoInsideCaptchaProvider = (props) => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const {executeRecaptcha} = useGoogleReCaptcha()

  const onInput = (fieldName) => {
    return (e) => {
      e.preventDefault()
      setData({...data, [fieldName]: e.target.value})
    }
  }

  const fields = props.freeGuidePage
  ? [
      { label: 'First name', field: 'firstName', type: 'text', required: true },
      { label: 'Email', field: 'email', type: 'email', required: true }
    ]
  : props.firstShootOfferPage
    ? [
        { label: 'Email', field: 'email', type: 'email', required: true }
      ] : [
    {label: 'First name', field: 'firstName', type: 'text', required: true},
    {label: 'Last name', field: 'lastName', type: 'text', required: true},
    {label: 'Email', field: 'email', type: 'email', required: true},
    {label: 'Phone number', field: 'phoneNumber', type: 'text'}
  ]

  const onSubmitWithRecaptcha = useCallback(async (e) => {
    if (!executeRecaptcha) {
      return;
    }

    e.preventDefault()
    const token = await executeRecaptcha('bookConsultationDiscount');
    onSubmit(e, token)
  }, [executeRecaptcha, data]);

  const onSubmit = (e, token) => {
    e.preventDefault()

    setLoading(true)
    if (props.callbackPage){
      sendBookConsultationCallback(data, token).then(() => {
        setLoading(false)
        props.onCompleted(data)
      }).catch(() => {
        setLoading(false)
      })
    } else if (props.freeGuidePage){
      sendFreeGuide(data, token).then(() => {
        setLoading(false)
        props.onCompleted(data)
      }).catch(() => {
        setLoading(false)
      })
     } else if (props.firstShootOfferPage){
      sendFirstShootOffer(data, token).then(() => {
        setCookie(PENDING_DISCOUNT_COOKIE, PENDING_DISCOUNT_CODE, 30)
        setLoading(false)
        props.onCompleted(data)
      }).catch(() => {
        setLoading(false)
      })
    } else {
      sendBookConsultationDiscount(data, token).then(() => {
        setCookie(PENDING_DISCOUNT_COOKIE, PENDING_DISCOUNT_CODE, 30)
        setLoading(false)
        props.onCompleted(data)
      }).catch(() => {
        setLoading(false)
      })
    }
  }

  return <form onSubmit={onSubmitWithRecaptcha}>
      {!props.firstShootOfferPage && <div className="initial-info-container title-container">
      {props.freeGuidePage && <div className="apply-for-discount-initial-info-title">Is Your Listing Actually Ready for the Camera?</div>}
      <h1 style={props.freeGuidePage ? { marginBottom: '15px' } : null}>{props.freeGuidePage ? "Stop Wasting Money on Listing Photos Until You Read This" : "Get More Showings With Professional Real Estate Media"}</h1>
      {props.freeGuidePage && <div className="apply-for-discount-initial-info-subtitle" style={{ marginBottom: '15px' }}>Download The Exact Checklist Top Agents Hand Their Sellers Before Every Shoot</div>}
      {props.freeGuidePage && <div className="apply-for-discount-initial-info-title" style={{ marginBottom: '5px' }}>⭐⭐⭐⭐⭐ 100+ 5-Star Google Reviews</div>}
      {props.freeGuidePage && <div className="apply-for-discount-initial-info-title">Trusted by 2,000+ agents</div>}
    </div>}

    <div
        className="initial-info-container content-container"
        style={props.freeGuidePage ? { paddingTop: '40px' } : undefined}
      >
        {!props.callbackPage && !props.freeGuidePage && !props.firstShootOfferPage && (
          <div className="apply-for-discount-initial-info-title">
            Don't miss out on this limited time offer.
          </div>
        )}
        {props.firstShootOfferPage && (
          <div className="apply-for-discount-initial-info-title">
            Congrats, Your Guide Has Been Sent! Here's a Gift..
          </div>
      )}

        {!props.freeGuidePage && (
        props.callbackPage ? <div className="apply-for-discount-initial-info-subtitle">
          Leave your info and we'll call you back to get your next listing booked.
        </div> : props.firstShootOfferPage ? <div className="apply-for-discount-initial-info-subtitle">
          Claim Your <span className="blue-bg">20%</span> Off Discount Code
        </div> : <div className="apply-for-discount-initial-info-subtitle">
          Claim your <span className="blue-bg">20%</span> discount code
        </div>
      )}

        <div className="lead-page-divider" />

        <div className="apply-for-discount-form">
          {fields.map((field, i) => (
            <div className={`apply-for-discount-form-field ${props.firstShootOfferPage ? 'w-100' : ''}`} key={`field-${i}`}>
              <label id="formLabel" className={`formLabel ${field.required ? 'required' : ''}`}>{field.label}</label>
              <input className="formInput" placeholder="Content" value={data[field.field]}
                     onInput={onInput(field.field)} required={field.required} type={field.type}/>
            </div>
          ))}
        </div>

        <div className="lead-page-divider" />

        {props.callbackPage ? <button className="projectEditButton projectEditButtonBlue w-100" type="submit" disabled={loading}>
          Submit
        </button> : props.freeGuidePage ? <button className="projectEditButton projectEditButtonBlue w-100" type="submit" disabled={loading}>
          Send Me The Checklist
        </button> : props.firstShootOfferPage ? <button className="projectEditButton projectEditButtonBlue w-100" type="submit" disabled={loading}>
          Email Code
        </button> : <button className="projectEditButton projectEditButtonBlue w-100" type="submit" disabled={loading}>
          Email Code
        </button>}

        <div className="apply-for-discount-terms">
          {props.callbackPage ? "By clicking Submit, I agree to the Privacy Policy and Terms of Service" : props.freeGuidePage ? "By clicking Send Me The Checklist, I agree to the Privacy Policy and Terms of Service" : "By clicking Email Code, I agree to the Privacy Policy and Terms of Service"}
        </div>
      </div>
  </form>
}

export default InitialInfoInsideCaptchaProvider

export const InitialInfo = (props) => {
  return <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_SITEKEY}>
    <InitialInfoInsideCaptchaProvider {...props} />
  </GoogleReCaptchaProvider>
}